import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { BazisMapService } from '@bazis/map/services/map.service';
import { BazisDefaultPopupComponent } from '@bazis/map/components/popups/default-popup.component';
import { BazisMapComponent } from '@bazis/map/map.component';
import { BazisSharedModule } from '@bazis/shared/shared.module';
import { BazisMyLocationComponent } from '@bazis/map/components/controls/my-location.component';
import { BazisOpenModalComponent } from '@bazis/map/components/controls/open-modal.component';
import { BazisZoomComponent } from '@bazis/map/components/controls/zoom.component';
import { BazisMapModalComponent } from '@bazis/map/components/modals/map-modal.component';
import { BazisTilesComponent } from '@bazis/map/components/controls/tiles.component';
import { BazisFullscreenComponent } from '@bazis/map/components/controls/fullscreen.component';

const DECLARATIONS = [
    BazisDefaultPopupComponent,
    BazisMapComponent,
    BazisMyLocationComponent,
    BazisZoomComponent,
    BazisTilesComponent,
    BazisOpenModalComponent,
    BazisMapModalComponent,
    BazisFullscreenComponent,
];

@NgModule({
    imports: [CommonModule, BazisSharedModule, TranslocoModule],
    declarations: DECLARATIONS,
    exports: DECLARATIONS,
    providers: [
        BazisMapService,
        {
            provide: TRANSLOCO_SCOPE,
            useValue: ['map'],
        },
    ],
})
export class BazisMapModule {}
